var _path, _path2, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLoginBgDark(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 488,
    height: 900,
    viewBox: "0 0 488 900",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.08,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M470.138 177.487C487.902 182.567 492.977 202.886 482.827 218.126L396.547 322.263L289.967 454.34L170.698 604.196L-96.6291 935H-281V-64L470.138 177.487ZM5.03696 305.486C6.71591 304.646 8.3949 303.806 10.0739 302.686C50.3685 281.405 91.7825 262.365 133.196 244.445L107.453 158.203C105.214 149.243 113.049 141.403 122.004 144.763L331.312 211.964C339.147 214.204 341.386 223.164 336.908 229.884L298.852 275.805L251.842 334.046L199.235 400.128C193.638 406.848 182.446 404.608 180.207 396.767L171.253 365.407L155.582 318.366C151.105 319.486 145.509 321.726 141.032 323.966C138.793 324.526 136.274 325.366 133.756 326.206C131.238 327.046 128.719 327.886 126.481 328.446C124.242 329.006 122.004 329.846 119.765 330.686C117.526 331.526 115.288 332.366 113.049 332.926C107.453 335.166 101.856 337.406 96.2597 338.526L79.4702 345.247C77.2317 345.807 75.2729 346.647 73.3141 347.487C71.3553 348.327 69.3966 349.167 67.158 349.727C62.9574 351.595 58.7567 353.268 54.6373 354.909C48.8777 357.204 43.2768 359.435 38.0563 362.047C34.6984 363.727 31.3405 365.127 27.9825 366.527C24.6247 367.927 21.2668 369.327 17.9089 371.007C12.3124 373.247 0.000183105 378.847 0.000183105 378.847V308.286C1.67911 307.166 3.35803 306.326 5.03696 305.486Z",
    fill: "url(#paint2_linear)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.08,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M392.252 188.963C407.913 193.443 412.388 211.362 403.439 224.802L327.369 316.639L233.401 433.115L128.246 565.27L-107.447 857H-270V-24L392.252 188.963ZM5.03687 305.486C6.71579 304.646 8.39471 303.806 10.0736 302.686C50.3683 281.405 91.7823 262.365 133.196 244.445L107.452 158.203C105.214 149.243 113.049 141.403 122.003 144.763L331.312 211.964C339.147 214.204 341.385 223.164 336.908 229.884L298.852 275.805L251.842 334.046L199.235 400.128C193.638 406.848 182.445 404.608 180.207 396.767L171.252 365.407L155.582 318.366C151.105 319.486 145.509 321.726 141.031 323.966C138.793 324.526 136.274 325.366 133.756 326.206C131.237 327.046 128.719 327.886 126.48 328.446C124.242 329.006 122.003 329.846 119.765 330.686C117.526 331.526 115.288 332.366 113.049 332.926C107.452 335.166 101.856 337.406 96.2595 338.526L79.47 345.247C77.2314 345.807 75.2727 346.647 73.3139 347.487C71.3551 348.327 69.3964 349.167 67.1578 349.727C62.9571 351.595 58.7565 353.268 54.637 354.909C48.8774 357.204 43.2765 359.435 38.0561 362.047C34.6982 363.727 31.3403 365.127 27.9825 366.527C24.6245 367.927 21.2666 369.327 17.9087 371.007C12.3122 373.247 -3.05176e-05 378.847 -3.05176e-05 378.847V308.286C1.67892 307.166 3.35791 306.326 5.03687 305.486Z",
    fill: "url(#paint3_linear)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear",
    x1: 488,
    y1: 192.837,
    x2: -72.9787,
    y2: 333.085,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear",
    x1: 408,
    y1: 202.5,
    x2: -169.5,
    y2: 362,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLoginBgDark);
export default __webpack_public_path__ + "static/media/login-bg-dark.bc0832747b70f04d5599f3184957a518.svg";
export { ForwardRef as ReactComponent };